ped_map_handler = {

    properties: {
    },

    onLoad: function(){
        var self = this;
        step_one_handler.showContent();
        add_feature_handler.properties.selectedCategory = 'walking';
        geojson_loader_handler.removeData();
        geojson_loader_handler.loadData('ped-gap');

        if (properties.commentsToggle){
            $( "#map-comments" ).prop('checked', true);
            mapData.pointsLayer.clearLayers();
            mapData.lineStringLayer.clearLayers();
            geojson_loader_handler.loadComments('walking');

        }


    },

    events: function() {
        var self = this;
        self.onLoad();

        step_one_handler.events();

        $( "#map-comments" ).change(function() {
          var hide = $(this).is(':checked'); 
          
          if (hide){
            properties.commentsToggle = true;
            geojson_loader_handler.loadComments('walking');

          }
          else{
            properties.commentsToggle = false;
            mapData.pointsLayer.clearLayers();
            mapData.lineStringLayer.clearLayers();
          }
          return false;
        });

    }
}